import React, { useState, useEffect, useRef } from "react";
import { data } from "../variables/variables";
import { BannerCard } from "../Components/cards/BannerCard";
import { CloseButton, Spinner } from "react-bootstrap";
import moment from "moment";
import axios from "axios";
import { Card } from "../Components/cards/Card";
import { AlertModal } from "../Components/ViewModals/Modal";
import { Header } from "./../Layouts/Header";
import { Navigate } from "react-router-dom";
import { OrdersBanner } from "../Components/cards/OrdersBanner";
import { NewOrder } from "../Components/ViewModals/NewOrder";
import { Modal } from "react-bootstrap";
import Floor from "../Floor_Component/Floor";
import Floor_Sidebar from "../Floor_Component/Floor_Sidebar";

//APIS URL
import {
  get_rooms_url,
  get_all_orders,
  update_orders_status,
  update_order_prepare,
  refresh_time,
  get_floors,
} from "./apis";

//STYLES FiLES
import "./../Assets/css/main.css";
import "./../Assets/css/Card.css";
import "./../Assets/css/utility.css";
import { OrderNotification } from "../Components/OrderPopup/OrderNotification";
import { notifyOnNewOrders } from "../Utils/notificationSound";
import { useOrderRealtime } from "../Utils/useOrderRealtime";
import {
  ensureNotificationPermissionAsked,
  showOrderBrowserNotification,
  showOrderBrowserNotificationFromPayload,
} from "../Utils/browserNotifications";

const Kitchen = () => {
  const [showModal, setShowModal] = useState(false);
  const [display_banner, setDisplay_banner] = useState(false);
  const [allRooms, setAllRooms] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [roomsResponse, setRoomsResponse] = useState(false);
  const [order_id, setOrder_id] = useState(0);
  const [st_id, setSt_id] = useState(0);
  const [room_name, setRoom_name] = useState("");
  const [prepare, setPrepare] = useState(0);
  const [redirectLogin, setRedirectLogin] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [responseApi, setResponseApi] = useState(0);
  const [loading, setLoading] = useState(false);
  const [newOrder, setNewOrder] = useState([]);
  const [roomName, setRoomName] = useState("");
  const [orderModal, setOrderModal] = useState(false);
  const [room_code, setRoom_code] = useState("");
  const [floors, setFloors] = useState([]);
  const floorRef = useRef([]);
  const ordersRef = useRef([]);
  const knownOrderIdsRef = useRef(null);
  const openRoomFromNotificationRef = useRef(() => {});
  const [showRightSide, setShowRightSide] = useState(false);
  const [roomObj, setRoomObj] = useState({});
  const [newOrderPopup, setNewOrderPopup] = useState([]);
  const [checkOrder, setCheckOrder] = useState(false);

  let my_floors = [];
  let use_effect_check = true;
  // const [roomColor, setroomColor] = useState(lightblue);

  //SetHeader Value
  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  useEffect(() => {
    // If user is already logged in and never answered the prompt, ask once.
    ensureNotificationPermissionAsked();
  }, []);

  useEffect(() => {
    if (use_effect_check) {
      axios
        .get(get_floors, { headers })
        .then((res) => {
          getAllOrders();
          if (res?.data?.status === 200) {
            setFloors(res?.data?.floors);
            my_floors = res?.data?.floors;
            setRoomsResponse(true);
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401 || err?.response?.status === 403) {
            setRedirectLogin(true);
          } else {
            setFetchError(data["error"]);
            setResponseApi(1);
            setRoomsResponse(false);
          }
        });

      use_effect_check = false;
    }
  }, []);

  const getAllOrders = () => {
    axios
      .get(get_all_orders + "/" + 3, { headers })
      .then((res) => {
        if (res?.data?.status === 200) {
          setAllOrders(res?.data?.orders);
          let newOreders = res?.data?.orders;
          let new_array = [];

          const { newOrders } = notifyOnNewOrders(
            newOreders,
            knownOrderIdsRef
          );
          newOrders.forEach((order) => {
            showOrderBrowserNotification(order, {
              onClick: () => {
                openRoomFromNotificationRef.current(
                  order?.room?.id ?? order?.room_id,
                  order?.room
                );
              },
            });
          });

          newOreders.map((item) => {
            let check = new_array.some((el) => el?.room_id == item?.room_id);

            if (check) {
              let old_order = new_array.filter(
                (ele) => ele.room_id == item.room_id
              );

              old_order = old_order[0];
              new_array = new_array.filter(
                (ele) => ele.room_id != item.room_id
              );
              if (old_order.status_id > item.status_id) {
                // new_array = [...new_array, item];

                new_array.push(item);
              } else if (old_order?.status_id == item.status_id) {
                if (item.prepared === 0) {
                  new_array.push(item);
                } else {
                  new_array.push(old_order);
                }
              } else {
                new_array.push(old_order);
                // new_array = [...new_array, old_order];
              }
            } else {
              new_array.push(item);
            }
          });

          setNewOrderPopup(new_array);
          //setNewOrder(uniqueNames);
          let deepCopy = JSON.parse(JSON.stringify(my_floors));

          deepCopy = deepCopy.map((floor) => {
            let update_room = floor?.rooms.map((room) => {
              if (new_array.length > 0) {
                new_array.map((item) => {
                  let check = new_array.some((el) => el?.room_id === room?.id);

                  if (check) {
                    if (item?.room_id === room?.id) {
                      if (item?.status_id === 2 && item?.prepared === 1) {
                        room = {
                          ...room,
                          ord_status: item?.status_id,
                          blink: true,
                        };
                      } else {
                        room = {
                          ...room,
                          ord_status: item?.status_id,
                          blink: false,
                        };
                      }
                    }
                  } else {
                    room = {
                      ...room,
                      ord_status: 0,
                    };
                  }
                });
              } else {
                room = {
                  ...room,
                  ord_status: 0,
                };
              }

              return room;
            });
            return { ...floor, rooms: update_room };
          });

          my_floors = deepCopy;
          setFloors(my_floors);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setRedirectLogin(true);
        }
      });
  };

  const handleRoomObj = (id, roomData = null) => {
    console.log('handleRoomObj called with id:', id, 'roomData:', roomData);
    console.log('Current floors:', floors);
    
    let obj = null;
    
    // If room data is provided directly (from order notification), use it
    if (roomData && roomData.id) {
      console.log('Using provided room data:', roomData);
      obj = roomData;
    } else {
      // Try to find room by id in floors (handle both string and number)
      floors.forEach((floor) => {
        if (floor?.rooms && Array.isArray(floor.rooms)) {
          floor.rooms.forEach((room) => {
            // Compare both as numbers and as strings to handle type mismatches
            if (room?.id && (
              Number(room.id) === Number(id) || 
              String(room.id) === String(id) ||
              room.id === id
            )) {
              obj = room;
              console.log('Room found in floors:', room);
            }
          });
        }
      });
    }

    if (obj) {
      setRoomObj(obj);
      setShowRightSide(true);
      console.log('Room object set successfully:', obj);
    } else {
      console.error('Room not found with id:', id);
      console.error('Available room IDs:', floors.flatMap(f => f?.rooms?.map(r => ({ id: r?.id, name: r?.name, code: r?.code })) || []));
      
      // Last resort: create a minimal room object from the ID
      // This allows the sidebar to at least try to load orders
      if (id) {
        console.warn('Creating minimal room object from ID:', id);
        const minimalRoom = {
          id: Number(id) || id,
          name: `Room#${id}`,
          code: null,
          room_status_id: 1 // Assume active
        };
        setRoomObj(minimalRoom);
        setShowRightSide(true);
      }
    }
  };

  openRoomFromNotificationRef.current = handleRoomObj;

  // Live push from Reverb + slow fallback poll (refresh_time).
  useOrderRealtime(getAllOrders, {
    departmentId: 3,
    fallbackMs: Number(refresh_time) || 15000,
    onEvent: (payload) => {
      if (
        payload?.department_id != null &&
        Number(payload.department_id) !== 3
      ) {
        return;
      }
      // Mark known so the follow-up poll does not notify twice.
      if (payload?.order?.id != null && knownOrderIdsRef.current) {
        knownOrderIdsRef.current.add(payload.order.id);
      }
      showOrderBrowserNotificationFromPayload(payload, {
        onClick: () => {
          const room = payload?.order?.room;
          openRoomFromNotificationRef.current(
            room?.id ?? payload?.order?.room_id,
            room
          );
        },
      });
    },
  });

  // checked login and not
  if (!user?.token || redirectLogin) {
    return <Navigate replace to="/login" />;
  }

  return (
    <div className="wrapper">
      <Header
        userName="Kitchen"
        // move_floor={handleMove}
      />
      <div className="wrapper_content">
        <div className="main_container">
          {display_banner ? (
            <BannerCard
              status={st_id}
              setDisplay_banner={setDisplay_banner}
              setSt_id={setSt_id}
              room_name={room_name}
              prepare={prepare}
            />
          ) : (
            ""
          )}

          <div className="row " style={{ width: "100%" }}>
            <div
              className={`${
                showRightSide
                  ? "col-lg-8 col-md-8 col-sm-12"
                  : "col-lg-12 col-md-12 col-sm-12"
              }`}
            >
              {floors.map((floor) => (
                <Floor
                  key={floor?.id}
                  floorName={floor?.floor_name}
                  floor_rooms={floor.rooms}
                  setRoomObj={setRoomObj}
                  setShowRightSide={setShowRightSide}
                  showRightSide={showRightSide}
                  // roomColor={roomColor}
                  setCheckOrder={setCheckOrder}
                />
              ))}
            </div>
            {showRightSide && (
              <div className="col-lg-4 col-md-8 col-sm-12 floor_sidebar_design">
                <Floor_Sidebar
                  roomObj={roomObj}
                  setShowRightSide={setShowRightSide}
                  setRoomObj={setRoomObj}
                  showRightSide={showRightSide}
                  checkOrder={checkOrder}
                  setCheckOrder={setCheckOrder}
                />
              </div>
            )}
          </div>

          <OrderNotification
            newOrderPopup={newOrderPopup}
            setShowRightSide={setShowRightSide}
            handleRoomObj={handleRoomObj}
          />
        </div>
      </div>
    </div>
  );
};

export default Kitchen;
